export default __webpack_public_path__ + "static/media/join_us_s.a091c3dc.jpg";